import React from "react"
import { makeStyles } from "tss-react/mui"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { FormikSwitch, FormikTextArea, FormikTextField } from "../../../../../../shared/components/forms/Formik"
import { CreateOrEditProductNumber, ProductNumberHistory } from "../productNumbersTypes"
import { FormAsideHistoryContainer } from "./FormAsideHistoryContainer"
import { StandardForm } from "../../../../../../shared/components/forms/StandardForm"
import { StandardMainPanel } from "../../../../../../shared/components/forms/StandardMainPanel"
import { StandardSidePanel } from "../../../../../../shared/components/forms/StandardSidePanel"

const useStyles = makeStyles()(() => ({
    codeInput: {
        width: "20rem",
    },
}))

export function FormProductGroupNumberContent({ history }: { history?: ProductNumberHistory }) {
    const { classes } = useStyles()

    return (
        <StandardForm>
            <StandardMainPanel>
                <LocalizedStrict id="supplier-admin-erp-product-group-numbers-field-code" attrs={{ label: true }}>
                    <FormikTextField<CreateOrEditProductNumber>
                        className={classes.codeInput}
                        name="code"
                        label="ERP number"
                        fullWidth
                    />
                </LocalizedStrict>
                <LocalizedStrict id="supplier-admin-erp-product-group-numbers-field-name" attrs={{ label: true }}>
                    <FormikTextField<CreateOrEditProductNumber> name="name" label="Name" fullWidth />
                </LocalizedStrict>
                <LocalizedStrict
                    id="supplier-admin-erp-product-group-numbers-description"
                    attrs={{ label: true, placeholder: true }}
                >
                    <FormikTextArea<CreateOrEditProductNumber>
                        minRows={3}
                        placeholder="Here you can explain the usage of this product group number"
                        name="description"
                        label="Description"
                    />
                </LocalizedStrict>
            </StandardMainPanel>
            <LocalizedStrict id="supplier-admin-erp-product-group-numbers-aside-settings" attrs={{ title: true }}>
                <StandardSidePanel variant="collapsible" title="Settings">
                    <LocalizedStrict id="supplier-admin-erp-product-group-numbers-active">
                        <FormikSwitch<CreateOrEditProductNumber> name="isActive">Active:</FormikSwitch>
                    </LocalizedStrict>
                </StandardSidePanel>
            </LocalizedStrict>
            {history && (
                <LocalizedStrict id="supplier-admin-erp-product-group-numbers-history" attrs={{ title: true }}>
                    <StandardSidePanel variant="collapsible" title="History">
                        <FormAsideHistoryContainer history={history} />
                    </StandardSidePanel>
                </LocalizedStrict>
            )}
        </StandardForm>
    )
}
